module.exports = __webpack_public_path__ + "static/media/Capitan Amerika 3.84d2f49b.jpg";